<div oui-dialog-title>
  Ajouter une version
  <oui-button type="icon" oui-dialog-close>
    <oui-icon>close</oui-icon>
  </oui-button>
</div>

<oui-dialog-content [scroll]="false">
  <div class="flex-vertical gap-24">
    <div class="flex-vertical flex-start gap-24 flex-center justify-center" *ngIf="!isloading">
      <oui-file-uploader
        class="width-100pc"
        type="multi"
        [(value)]="files"
        [maxFileSize]="10"
        accept=".docx"
        hint="Fichiers supportés : word (.docx) / Taille max : 10 Mo"
        *ngIf="!files || files?.length === 0"></oui-file-uploader>
      <div class="files-container" *ngIf="(files?.length ?? 0) > 0">
        <oui-file-item *ngFor="let file of files" [file]="file" (delete)="deleteFile(file)"></oui-file-item>
      </div>
    </div>
    <div class="flex-horizontal flex-center justify-center">
      <oui-loading *ngIf="isloading"></oui-loading>
    </div>
    <div class="flex-vertical gap-32" *ngIf="!isloading">
      <div>
        <oui-checkbox [control]="useReferenceControl" [label]="useReferencelabel"></oui-checkbox>
      </div>
      <div class="flex-vertical gap-16">
        <div class="flex-horizontal gap-16 majeur">
          <div class="flex-vertical">
            <oui-checkbox [control]="majeurVersionControl" [label]="majeurVersionLabel"></oui-checkbox>
            <div class="body-2 color-on-surface-medium">Rend obsolète les versions précédentes</div>
          </div>
          <oui-date-picker
            label="Date limite de conformité"
            [(value)]="conformiteDate"
            *ngIf="majeurVersionControl.value"></oui-date-picker>
        </div>
        <oui-textarea
          class="width-100pc"
          [control]="commentaireControl"
          placeholder="Commentaire de version"
          *ngIf="majeurVersionControl.value"
          [resizeEnabled]="true"></oui-textarea>
      </div>
    </div>
  </div>
</oui-dialog-content>

<oui-dialog-actions>
  <oui-button type="text" class="flex-none" oui-dialog-close> Annuler </oui-button>
  <oui-button
    type="contained"
    class="flex-none"
    (click)="onValid()"
    [disabled]="(!isloading && !files) || (!!files && files.length === 0)">
    Valider
  </oui-button>
</oui-dialog-actions>
